import api from '../utils/request';
import { getCurrentUserId, isTrialUser } from '../utils/subscriptionUtils';

const trialUsageApi = {
  async checkUsage(featureName) {
    try {
      const userId = getCurrentUserId();
      if (userId) {
        try {
          const trial = await isTrialUser(userId);
          if (!trial) {
            return {
              can_use: true,
              total_used: 0,
              remaining: 0,
              limit: 0,
              is_trial_user: false,
            };
          }
        } catch (_) {}
      }

      const response = await api.get('/trial-usage/check', {
        params: { feature_name: featureName }
      });
      return response.data;
    } catch (error) {
      return {
        can_use: true,
        total_used: 0,
        remaining: 180,
        limit: 180,
        is_trial_user: false,
      };
    }
  },

  async recordUsage(recordData) {
    try {
      const userId = getCurrentUserId();
      if (userId) {
        try {
          const trial = await isTrialUser(userId);
          if (!trial) {
            return { success: true, message: '非体验版用户，无需记录' };
          }
        } catch (_) {}
      }

      const response = await api.post('/trial-usage/record', {
        feature_name: recordData.feature_name,
        session_id: recordData.session_id || null,
        start_time: recordData.start_time.toISOString(),
        end_time: recordData.end_time ? recordData.end_time.toISOString() : null,
        duration_seconds: recordData.duration_seconds,
      });
      return response.data;
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async getStatus(featureName) {
    try {
      const userId = getCurrentUserId();
      if (userId) {
        try {
          const trial = await isTrialUser(userId);
          if (!trial) {
            return {
              can_use: true,
              total_used: 0,
              remaining: 0,
              limit: 0,
              is_trial_user: false,
            };
          }
        } catch (_) {}
      }

      const response = await api.get('/trial-usage/status', {
        params: { feature_name: featureName }
      });
      return response.data;
    } catch (error) {
      return {
        can_use: true,
        total_used: 0,
        remaining: 180,
        limit: 180,
        is_trial_user: false,
      };
    }
  }
};

export default trialUsageApi;
